import {
    api, C, sampleFields, sampleInventory, sampleTreatments,
    FRUITETI_CROPS, OPEN_FIELD_CROP_GROUPS, WMO_CODES,
    PERMANENT_CROP_KEYWORDS, OFFLINE_QUEUE_KEY
} from './context.js';
import { loadApplicationData } from './data.js';
import { switchTab } from './nav.js';
import { renderFieldsList } from './map.js';
import {
    populateTreatmentFieldOptions,
    renderRecentTreatments,
    populateLogCropFilter,
    renderFullLogTable,
    renderInventoryTable,
    updateDashboardStats,
    populateSettingsCompanyFields,
    updateSianTransmissionUi,
    refreshSettingsView
} from './activities.js';
export function showLoginScreen() {
    document.getElementById('login-screen').classList.remove('hidden');
    document.getElementById('login-step-email').classList.add('active');
    document.getElementById('login-step-otp').classList.remove('active');
    document.getElementById('login-step-loading').classList.remove('active');
}

export function hideLoginScreen() {
    document.getElementById('login-screen').classList.add('hidden');
}

export function showSetupWizard() {
    const wizard = document.getElementById('setup-wizard');
    wizard.classList.remove('hidden');
    wizard.style.display = 'flex';
    setTimeout(() => wizard.classList.add('show'), 10);
    
    document.getElementById('wizard-step-company').classList.add('active');
    document.getElementById('wizard-step-sian').classList.remove('active');
}

export function hideSetupWizard() {
    const wizard = document.getElementById('setup-wizard');
    wizard.classList.remove('show');
    setTimeout(() => wizard.style.display = 'none', 300);
}

export function showRegisterRequiredAlert(action) {
    alert(`Registrazione richiesta: Per poter ${action}, devi prima configurare il tuo account inserendo la tua email.`);
    showLoginScreen();
}

export function enterDemoMode() {
    C.currentUser = {
        id: 'demo',
        name: 'Ospite (Demo)',
        email: '',
        role: 'admin',
        isDemo: true
    };
    C.companyInfo = {
        id: 'demo-company',
        name: 'Azienda Agricola Demo',
        cuaa: 'DEMOCUAA1234567',
        sian_api_key: 'demo-api-key',
        sian_cuaa: 'DEMOCUAA1234567',
        sian_cert_name: 'certificato_demo.pem'
    };
    
    C.state.fields = [...sampleFields];
    C.state.treatments = [...sampleTreatments];
    C.state.carenzeTreatments = [...sampleTreatments];
    C.state.inventory = [...sampleInventory];

    hideLoginScreen();

    // Banner demo subito (prima di update UI che può fallire)
    const demoBanner = document.getElementById('demo-banner');
    if (demoBanner) demoBanner.classList.remove('hidden');
    const demoHeaderBadge = document.getElementById('demo-header-badge');
    if (demoHeaderBadge) demoHeaderBadge.classList.remove('hidden');
    const btnHeaderLogin = document.getElementById('btn-header-login');
    if (btnHeaderLogin) btnHeaderLogin.classList.remove('hidden');

    try { updateUserProfile(); } catch (e) { console.error('[AgriLog] updateUserProfile demo:', e); }
    
    const lockIcons = document.querySelectorAll('.lock-icon');
    lockIcons.forEach(icon => icon.classList.add('hidden'));

    // Aggiorna UI con dati demo (senza chiamate API)
    const safeDemoUi = (fn, label) => {
        try { fn(); } catch (e) { console.error(`[AgriLog] demo UI ${label}:`, e); }
    };
    safeDemoUi(renderFieldsList, 'fields-list');
    safeDemoUi(populateTreatmentFieldOptions, 'treatment-fields');
    safeDemoUi(renderRecentTreatments, 'recent-treatments');
    safeDemoUi(populateLogCropFilter, 'log-crop-filter');
    safeDemoUi(renderFullLogTable, 'log-table');
    safeDemoUi(renderInventoryTable, 'inventory');
    safeDemoUi(updateDashboardStats, 'dashboard');
    safeDemoUi(populateSettingsCompanyFields, 'settings');
    safeDemoUi(renderDemoOperatorsList, 'operators');
}

export function renderDemoOperatorsList() {
    const tbody = document.getElementById('operators-table-body');
    if (!tbody) return;
    tbody.innerHTML = '<tr><td colspan="5" style="text-align: center; color: var(--text-muted);"><i class="fa-solid fa-lock" style="margin-right:8px;"></i>Registrati per gestire gli operatori aziendali.</td></tr>';
}

export function exitDemoMode() {
    const demoBanner = document.getElementById('demo-banner');
    if (demoBanner) demoBanner.classList.add('hidden');
    const demoHeaderBadge = document.getElementById('demo-header-badge');
    if (demoHeaderBadge) demoHeaderBadge.classList.add('hidden');
    const btnHeaderLogin = document.getElementById('btn-header-login');
    if (btnHeaderLogin) btnHeaderLogin.classList.add('hidden');
}

export function clearDemoApplicationState() {
    C.state.fields = [];
    C.state.treatments = [];
    C.state.carenzeTreatments = [];
    C.state.inventory = [];
}

export function updateUserProfile() {
    if (!C.currentUser) return;
    
    const avatarEl = document.getElementById('user-avatar');
    const nameDisplayEl = document.getElementById('user-name-display');
    const roleDisplayEl = document.getElementById('user-role-display');
    
    if (C.currentUser.isDemo) {
        if (avatarEl) {
            avatarEl.innerHTML = '<i class="fa-solid fa-seedling" style="color: var(--warning-hover);"></i>';
            avatarEl.style.background = 'rgba(219, 109, 40, 0.15)';
        }
        if (nameDisplayEl) nameDisplayEl.textContent = 'Ospite (Demo)';
        if (roleDisplayEl) roleDisplayEl.textContent = 'Registrati per salvare';
        
        const logoutBtn = document.getElementById('btn-quick-logout');
        if (logoutBtn) {
            logoutBtn.className = 'fa-solid fa-right-to-bracket';
            logoutBtn.title = 'Accedi / Registrati';
            logoutBtn.style.color = 'var(--primary-hover)';
        }
    } else {
        if (avatarEl) {
            avatarEl.textContent = C.currentUser.name ? C.currentUser.name.charAt(0).toUpperCase() : 'U';
            avatarEl.style.background = 'linear-gradient(135deg, var(--primary) 0%, var(--accent) 100%)';
        }
        if (nameDisplayEl) nameDisplayEl.textContent = C.currentUser.name || C.currentUser.email;
        
        const roleLabels = {
            'admin': 'Amministratore',
            'agrotecnico': 'Agrotecnico Laureato',
            'agronomo': 'Dott. Agronomo',
            'perito_agrario': 'Perito Agrario',
            'fitosanitario': 'Fitosanitario',
            'trattorista': 'Trattorista',
            'altro': 'Altro'
        };
        const roleText = roleLabels[C.currentUser.role] || (C.currentUser.role.charAt(0).toUpperCase() + C.currentUser.role.slice(1));
        if (roleDisplayEl) {
            roleDisplayEl.textContent = roleText + (C.currentUser.patent ? ` (n. ${C.currentUser.patent})` : '');
        }
        
        const logoutBtn = document.getElementById('btn-quick-logout');
        if (logoutBtn) {
            logoutBtn.className = 'fa-solid fa-right-from-bracket';
            logoutBtn.title = 'Disconnetti';
            logoutBtn.style.color = 'var(--text-muted)';
        }
    }

    try {
        updateSianTransmissionUi();
    } catch (e) {
        console.warn('[AgriLog] updateSianTransmissionUi:', e);
    }

    // Abilita/Disabilita tab Impostazioni solo per Admin o Demo
    const settingsTabItem = document.getElementById('menu-settings');
    if (settingsTabItem) {
        if (C.currentUser.role === 'admin' || C.currentUser.isDemo) {
            settingsTabItem.classList.remove('hidden');
        } else {
            settingsTabItem.classList.add('hidden');
        }
    }

    // Applica restrizioni di ruolo per operatore Trattorista
    const activitySelect = document.getElementById('activity-type');
    const lockIcons = document.querySelectorAll('.lock-icon');
    
    if (C.currentUser.role === 'trattorista') {
        lockIcons.forEach(icon => icon.classList.remove('hidden'));
        
        if (activitySelect) {
            const optTrattamento = activitySelect.querySelector('option[value="trattamento"]');
            if (optTrattamento) optTrattamento.disabled = true;
            if (activitySelect.value === 'trattamento') {
                activitySelect.value = 'lavorazione';
                activitySelect.dispatchEvent(new Event('change'));
            }
        }
    } else {
        lockIcons.forEach(icon => icon.classList.add('hidden'));
        
        if (activitySelect) {
            const optTrattamento = activitySelect.querySelector('option[value="trattamento"]');
            if (optTrattamento) optTrattamento.disabled = false;
        }
    }
}

export async function checkAuthSession() {
    const forceDemo = new URLSearchParams(window.location.search).get('demo') === 'true';
    if (forceDemo) {
        api.clearToken();
        enterDemoMode();
        return true;
    }

    const token = api.getToken();
    if (!token) {
        enterDemoMode();
        return true;
    }
    
    try {
        const me = await api.getMe();
        C.currentUser = me.user;
        C.companyInfo = me.company;
        
        const activeSlug = localStorage.getItem('active_company_slug');
        if (C.companyInfo?.slug) {
            // Allinea lo slug salvato all'azienda dell'utente autenticato
            if (!activeSlug || activeSlug !== C.companyInfo.slug) {
                localStorage.setItem('active_company_slug', C.companyInfo.slug);
            }
        } else if (activeSlug) {
            // Slug branding obsoleto rispetto all'account senza azienda
            localStorage.removeItem('active_company_slug');
        }
        
        exitDemoMode();
        clearDemoApplicationState();
        
        if (!C.companyInfo && C.currentUser.role === 'admin') {
            showSetupWizard();
            return false;
        }
        
        updateUserProfile();
        hideLoginScreen();
        await loadApplicationData();
        return true;
    } catch (err) {
        console.error('Sessione non valida:', err);
        api.clearToken();
        enterDemoMode();
        return true;
    }
}

export function initLoginHandlers() {
    const btnRequestOtp = document.getElementById('btn-request-otp');
    const btnVerifyOtp = document.getElementById('btn-verify-otp');
    const btnBackEmail = document.getElementById('btn-back-email');
    const loginEmailInput = document.getElementById('login-email');
    const loginError = document.getElementById('login-error');
    const otpBoxes = document.querySelectorAll('.otp-box');
    
    // Auto-focus & Paste handler per codice OTP 6 cifre
    otpBoxes.forEach((box, idx) => {
        box.addEventListener('paste', (e) => {
            e.preventDefault();
            const pastedData = (e.clipboardData || window.clipboardData).getData('text').trim().replace(/[^0-9]/g, '');
            if (pastedData.length >= 6) {
                const digits = pastedData.slice(0, 6).split('');
                otpBoxes.forEach((b, i) => { b.value = digits[i] || ''; });
                otpBoxes[5].focus();
                if (btnVerifyOtp) btnVerifyOtp.click();
            }
        });
        box.addEventListener('input', () => {
            if (box.value.length === 1 && idx < otpBoxes.length - 1) {
                otpBoxes[idx + 1].focus();
            }
        });
        box.addEventListener('keydown', (e) => {
            if (e.key === 'Backspace' && box.value.length === 0 && idx > 0) {
                otpBoxes[idx - 1].focus();
            }
        });
    });

    let isSendingOtp = false;

    if (loginEmailInput) {
        loginEmailInput.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                if (!isSendingOtp) {
                    btnRequestOtp.click();
                }
            }
        });
    }

    btnRequestOtp.onclick = async (e) => {
        if (e) e.preventDefault();
        if (isSendingOtp) return;
        isSendingOtp = true;

        const email = loginEmailInput.value.trim();
        if (!email || !email.includes('@')) {
            alert('Inserisci un indirizzo email valido (es. nome@azienda.it).');
            isSendingOtp = false;
            return;
        }
        
        loginError.classList.add('hidden');
        btnRequestOtp.disabled = true;
        btnRequestOtp.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Invio in corso...';
        
        try {
            const res = await api.requestOtp(email);
            document.getElementById('otp-email-show').textContent = email;
            document.getElementById('login-step-email').classList.remove('active');
            document.getElementById('login-step-otp').classList.add('active');
            
            // Per facilitare i test di collaudo, mostriamo l'OTP simulato se presente nel corpo di risposta
            if (res._testOtp) {
                alert(`[TEST MODE] Codice OTP generato: ${res._testOtp}`);
                // Precompila i box
                const codeChars = res._testOtp.split('');
                otpBoxes.forEach((box, i) => {
                    box.value = codeChars[i] || '';
                });
            }
        } catch (err) {
            const msg = err.message.includes('503') || err.message.includes('Riprova')
                ? 'Impossibile inviare l\'email in questo momento. Riprova più tardi.'
                : err.message;
            loginError.textContent = msg;
            loginError.classList.remove('hidden');
        } finally {
            btnRequestOtp.disabled = false;
            btnRequestOtp.innerHTML = '<i class="fa-solid fa-paper-plane"></i> Invia Codice OTP';
            setTimeout(() => { isSendingOtp = false; }, 2000);
        }
    };

    btnVerifyOtp.addEventListener('click', async () => {
        const email = loginEmailInput.value.trim();
        const otp = Array.from(otpBoxes).map(box => box.value).join('');
        
        if (otp.length < 6) {
            loginError.textContent = 'Inserisci il codice di 6 cifre completo.';
            loginError.classList.remove('hidden');
            return;
        }
        
        loginError.classList.add('hidden');
        btnVerifyOtp.disabled = true;
        btnVerifyOtp.innerHTML = '<i class="fa-solid fa-spinner fa-spin"></i> Verifica in corso...';
        
        try {
            const companySlug = localStorage.getItem('active_company_slug') || null;
            const data = await api.verifyOtp(email, otp, companySlug);
            api.setToken(data.token);
            C.currentUser = data.user;
            C.companyInfo = data.company;

            if (C.companyInfo?.slug) {
                localStorage.setItem('active_company_slug', C.companyInfo.slug);
            }
            
            exitDemoMode();
            clearDemoApplicationState();
            
            document.getElementById('login-step-otp').classList.remove('active');
            document.getElementById('login-step-loading').classList.add('active');
            
            if (data.needsCompanySetup && C.currentUser.role === 'admin') {
                document.getElementById('login-step-loading').classList.remove('active');
                hideLoginScreen();
                showSetupWizard();
            } else {
                try { updateUserProfile(); } catch (e) { console.error('[AgriLog] updateUserProfile login:', e); }
                hideLoginScreen();
                document.getElementById('login-step-loading').classList.remove('active');
                await loadApplicationData();
                await refreshSettingsView();
            }
        } catch (err) {
            document.getElementById('login-step-loading').classList.remove('active');
            document.getElementById('login-step-otp').classList.add('active');
            loginError.textContent = err.message || 'Accesso non riuscito. Riprova.';
            loginError.classList.remove('hidden');
        } finally {
            btnVerifyOtp.disabled = false;
            btnVerifyOtp.innerHTML = '<i class="fa-solid fa-right-to-bracket"></i> Accedi';
        }
    });

    btnBackEmail.addEventListener('click', () => {
        document.getElementById('login-step-otp').classList.remove('active');
        document.getElementById('login-step-email').classList.add('active');
        loginError.classList.add('hidden');
        otpBoxes.forEach(box => box.value = '');
    });

    // Close login screen
    const btnCloseLogin = document.getElementById('btn-close-login');
    if (btnCloseLogin) {
        btnCloseLogin.addEventListener('click', () => {
            hideLoginScreen();
        });
    }

    // Continue as guest / demo
    const btnExploreDemo = document.getElementById('btn-explore-demo');
    if (btnExploreDemo) {
        btnExploreDemo.addEventListener('click', () => {
            enterDemoMode();
        });
    }

    // Open login modal from banner or header
    const btnHeaderLogin = document.getElementById('btn-header-login');
    if (btnHeaderLogin) {
        btnHeaderLogin.addEventListener('click', () => {
            showLoginScreen();
        });
    }
    const btnBannerLogin = document.getElementById('btn-banner-login');
    if (btnBannerLogin) {
        btnBannerLogin.addEventListener('click', () => {
            showLoginScreen();
        });
    }

    // Profile button click opens login modal in demo mode
    const profileBtn = document.getElementById('user-profile-btn');
    if (profileBtn) {
        profileBtn.addEventListener('click', () => {
            if (C.currentUser && C.currentUser.isDemo) {
                showLoginScreen();
            }
        });
    }

    // Quick logout
    const logoutBtn = document.getElementById('btn-quick-logout');
    if (logoutBtn) {
        logoutBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (C.currentUser && C.currentUser.isDemo) {
                showLoginScreen();
            } else {
                if (confirm('Sei sicuro di voler uscire?')) {
                    api.clearToken();
                    window.location.reload();
                }
            }
        });
    }

    // --- SETUP WIZARD HANDLERS ---
    const wizardStepCompany = document.getElementById('wizard-step-company');
    const btnWizardFinish = document.getElementById('btn-wizard-finish');
    const companyNameInput = document.getElementById('setup-company-name');
    const companyCuaaInput = document.getElementById('setup-cuaa');

    const completeCompanySetup = async () => {
        if (!companyNameInput.value.trim() || !companyCuaaInput.value.trim()) {
            alert('Inserisci Ragione Sociale e CUAA aziendale per continuare.');
            return;
        }
        
        const name = companyNameInput.value.trim();
        const cuaa = companyCuaaInput.value.trim();
        
        try {
            await api.setupCompany(name, cuaa);
            hideSetupWizard();
            // Ricarica la sessione per scaricare i dati configurati
            await checkAuthSession();
        } catch (err) {
            alert('Errore durante la configurazione aziendale: ' + err.message);
        }
    };

    if (btnWizardFinish) {
        btnWizardFinish.addEventListener('click', () => completeCompanySetup());
    }
}
export async function applyAziendaBranding() {
    const urlParams = new URLSearchParams(window.location.search);
    const aziendaSlug = urlParams.get('azienda');
    if (aziendaSlug) {
        localStorage.setItem('active_company_slug', aziendaSlug);
        window.history.replaceState({}, document.title, window.location.pathname);
    }
    
    const activeSlug = localStorage.getItem('active_company_slug');
    if (activeSlug) {
        try {
            const company = await api.getPublicCompany(activeSlug);
            if (company && company.name) {
                const titleEl = document.querySelector('.login-title');
                if (titleEl) titleEl.textContent = company.name;
                const subEl = document.querySelector('.login-subtitle');
                if (subEl) {
                    subEl.replaceChildren(
                        document.createTextNode('Quaderno di Campagna per '),
                        Object.assign(document.createElement('strong'), { textContent: company.name })
                    );
                }
            }
        } catch (e) {
            console.warn('[AgriLog] Errore caricamento branding azienda:', e.message);
        }
    }
}
